// Angular
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Services
import { AppCleanup } from '../../../shared/models';

// Models
import { UnitOfMeasureModel } from '../models/unit-of-measure.model';

@Injectable({
	providedIn: 'root',
})
export class UnitOfMeasureService extends AppCleanup {
	private unitOfMeasureUrl;

	constructor(private http: HttpClient) {
		super();
		this.unitOfMeasureUrl = `${this.apiUrl}api/unitofmeasure`;
	}

	getUnitsOfMeasure() {
		return this.http.get<UnitOfMeasureModel[]>(this.unitOfMeasureUrl);
	}

	getUnitOfMeasure(id: number) {
		return this.http.get<UnitOfMeasureModel>(`${this.unitOfMeasureUrl}/${id}`);
	}

	updateUnitOfMeasure(unitOfMeasure: UnitOfMeasureModel) {
		return this.http.put<UnitOfMeasureModel>(`${this.unitOfMeasureUrl}`, unitOfMeasure);
	}

	createUnitOfMeasure(unitOfMeasure: UnitOfMeasureModel) {
		return this.http.post<UnitOfMeasureModel>(`${this.unitOfMeasureUrl}`, unitOfMeasure);
	}

	deleteUnitOfMeasure(id: number) {
		return this.http.delete<UnitOfMeasureModel>(`${this.unitOfMeasureUrl}/${id}`);
	}
}
